import { render, staticRenderFns } from "./IconStarFilledSongIndex.vue?vue&type=template&id=45b6ef90"
import script from "./IconStarFilledSongIndex.vue?vue&type=script&lang=js"
export * from "./IconStarFilledSongIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports